import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useUserLanguage from "../hooks/useUserLanguage";
import useTranslations from "../hooks/useTranslations";

const ErrorCreative = () => {
  /* ───── i18n ───── */
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = useMemo(
    () =>
      (key, def = "") =>
        translations[key] || def,
    [translations]
  );

  return (
    <main className="auth-creative-wrapper">
      <div className="auth-creative-inner">
        <div className="creative-card-wrapper">
          <div className="card my-4 overflow-hidden" style={{ zIndex: 1 }}>
            <div className="row flex-1 g-0">
              {/* sol taraf */}
              <div className="col-lg-6 h-100 my-auto">
                <div className=" position-absolute translate-middle top-50 start-50">
                  <img
                    src={`${process.env.PUBLIC_URL}/icon.svg`}
                    alt="logo"
                    className="logo logo-sm"
                    width="50"
                    height="auto"
                  />
                </div>

                <div className="creative-card-body card-body p-sm-5 text-center">
                  <h2 className="fw‑bolder mb‑4" style={{ fontSize: 120 }}>
                    4<span className="text-danger">0</span>4
                  </h2>

                  <h4 className="fw‑bold mb‑2">
                    {getText("ERROR_404_TITLE", "Page not found")}
                  </h4>

                  <p className="fs‑12 fw‑medium text‑muted">
                    {getText(
                      "ERROR_404_MESSAGE",
                      "Sorry, the page you are looking for can't be found. Please check the URL or try a different page on our site."
                    )}
                  </p>

                  <div className="mt‑5">
                    <Link to="/" className="btn btn-light-brand w‑100">
                      {getText("BACK_HOME_BTN", "Back Home")}
                    </Link>
                  </div>
                </div>
              </div>

              {/* sağ taraf */}
              <div className="col-lg-6 bg-primary">
                <div className="h‑100 d‑flex align‑items‑center justify‑content‑center">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/auth/auth-user.png`}
                    alt="img"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ErrorCreative;
